"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.inventoryArticlesToStockChanges = exports.createPublishChangesBatches = void 0;
var createPublishChangesBatches = function (changedArticles) {
    var _a;
    var sortedArticles = changedArticles.sort(function (a, b) { return a.idProduct - b.idProduct; });
    var batches = [[]];
    var batchCnt = 0;
    while (sortedArticles.length) {
        var productId = sortedArticles[0].idProduct;
        var productCnt = 0;
        while (((_a = sortedArticles[productCnt]) === null || _a === void 0 ? void 0 : _a.idProduct) === productId)
            productCnt++;
        if (batches[batchCnt].length + productCnt < 100)
            batches[batchCnt] = __spreadArray(__spreadArray([], batches[batchCnt], true), sortedArticles.splice(0, productCnt), true);
        else if (productCnt <= 100) {
            batchCnt++;
            batches[batchCnt] = __spreadArray([], sortedArticles.splice(0, productCnt), true);
        }
        else {
            var numOfWholeHundreds = Math.floor(productCnt / 100);
            for (var i = 0; i < numOfWholeHundreds; i++) {
                batchCnt++;
                batches[batchCnt] = __spreadArray([], sortedArticles.splice(0, 100), true);
            }
            batchCnt++;
            batches[batchCnt] = __spreadArray([], sortedArticles.splice(0, productCnt - 100 * numOfWholeHundreds), true);
        }
    }
    return batches;
};
exports.createPublishChangesBatches = createPublishChangesBatches;
//dd
var inventoryArticlesToStockChanges = function (articles) {
    return {
        articlesToAdd: articles.reduce(function (list, article) {
            if (article.newQuantity && article.newQuantity > article.quantity) {
                var articleToAdd = article.copy().applyChanges();
                articleToAdd.quantity = article.newQuantity - article.quantity;
                list.push(articleToAdd.attributes);
            }
            return list;
        }, []),
        articlesToChange: articles.reduce(function (list, article) {
            if (article.hasEditedAttribute()) {
                var articleToChange = article.copy().applyChanges();
                articleToChange.quantity = Math.min(article.quantity, article.newQuantity || Infinity);
                list.push(articleToChange.attributes);
            }
            return list;
        }, []),
        articlesToDelete: articles.reduce(function (list, article) {
            if (typeof article.newQuantity === 'number' && article.newQuantity < article.quantity) {
                var articleToDelete = article.copy().applyChanges();
                articleToDelete.quantity = article.quantity - article.newQuantity;
                list.push(articleToDelete.attributes);
            }
            return list;
        }, []),
    };
};
exports.inventoryArticlesToStockChanges = inventoryArticlesToStockChanges;
//# sourceMappingURL=publishing.js.map